import type { MutableRefObject } from 'react';

export const executeCaptcha = async (
  captchaRef: MutableRefObject<{
    resetCaptcha: () => void;
    execute: (options: { async: boolean }) => Promise<{ response: string }>;
  }>,
) => {
  try {
    captchaRef.current.resetCaptcha();
    const { response: captchaToken } = await captchaRef.current.execute({
      async: true,
    });
    return captchaToken;
  } catch (error) {
    console.error('Error processing you request:', error);
  }
};
